import {
  AgentComponentType,
  type UnpublishedComponentChange,
  type UnpublishedToolChange,
} from '@reach/shared-types/agent-components';
import { Modal } from '../../../components/common/Modal';
import { COMPONENT_TYPE_COPY, NAV_COPY } from '../agents-copy';
import { UnpublishedChangeGroup } from './UnpublishedChangeGroup';
import { UnpublishedChangeItem } from './UnpublishedChangeItem';
import { UnpublishedToolChangeItem } from './UnpublishedToolChangeItem';
import styles from './UnpublishedChangesDialog.module.css';

interface UnpublishedChangesDialogProps {
  changes: UnpublishedComponentChange[];
  toolChanges: UnpublishedToolChange[];
  onClose: () => void;
}

const COMPONENT_TYPE_ORDER = [
  AgentComponentType.GUIDANCE,
  AgentComponentType.SKILL,
  AgentComponentType.ESCALATION,
];

export const UnpublishedChangesDialog = ({
  changes,
  toolChanges,
  onClose,
}: UnpublishedChangesDialogProps) => {
  const changeGroups = COMPONENT_TYPE_ORDER.map(type => ({
    type,
    changes: changes.filter(change => change.type === type),
  })).filter(group => group.changes.length > 0);
  const toolsChanged = toolChanges.length > 0;

  return (
    <Modal title="Unsynced changes" description="Tenants get these when you sync." onClose={onClose}>
      <div className={styles.changeGroups}>
        {changeGroups.map(group => (
          <UnpublishedChangeGroup key={group.type} title={COMPONENT_TYPE_COPY[group.type].title}>
            {group.changes.map(change => (
              <UnpublishedChangeItem key={change.componentId} change={change} />
            ))}
          </UnpublishedChangeGroup>
        ))}
        {toolsChanged && (
          <UnpublishedChangeGroup title={NAV_COPY.tools}>
            {toolChanges.map(change => (
              <UnpublishedToolChangeItem key={change.toolId} change={change} />
            ))}
          </UnpublishedChangeGroup>
        )}
      </div>
    </Modal>
  );
};
